<template>
    <div class="update-instrument-name-dialog">
        <b-form class="dialog-form" @submit.prevent="save">
            <div class="instrument-name-container">
                <span class="instrument-code"> {{ instrumentText }} {{ instrument.esId }} </span>
                <span class="instrument-eq">=</span>
                <b-form-input
                    v-model="name"
                    placeholder=""
                    class="rounded-1 instrument-input"
                    :class="{ 'is-invalid': !name }"
                />
            </div>
            <div class="update-message-div">
                <span>{{ $translate('are_you_sure_make_this_change') }}</span>
            </div>
            <div class="dialog-action-container">
                <b-button variant="link" class="cancel-btn" @click="hide">
                    {{ $translate('cancel') }}
                </b-button>
                <b-button
                    variant="primary"
                    class="btn-submit"
                    :disabled="!formIsValid"
                    type="submit"
                >
                    {{ $translate('save') }}
                </b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
import BackendProvider from '../../../business/services/BackendProvider'
import UIUtils from '../../../business/utils/UIUtils'
import { INSTRUMENT_TYPE } from '../../../business/const'

export default {
    name: 'UpdateInstrumentNameDialog',
    props: {
        instrument: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            name: this.instrument.name
        }
    },
    computed: {
        formIsValid() {
            return this.name && this.name !== this.instrument.name
        },
        instrumentText() {
            if (
                this.instrument.type &&
                [INSTRUMENT_TYPE.GERI, INSTRUMENT_TYPE.MIRI].includes(this.instrument.type)
            )
                return null
            return this.$translate('instrument')
        }
    },
    methods: {
        async save() {
            try {
                UIUtils.showLoadingMask()
                await BackendProvider.updateInstrument(this.instrument._id, { name: this.name })
                this.$emit('updateInstrument', this.name)
                UIUtils.hideLoadingMask()
                this.hide()
            } catch (e) {
                UIUtils.toast('error', 'error', 3000, 'update-notification')
            }
        },
        hide() {
            this.$emit('hide')
        }
    }
}
</script>

<style lang="scss" scoped>
.update-instrument-name-dialog {
    position: absolute;
    top: 50px;
    z-index: 99;
    background-color: $dark-4;
    color: $light-3;
    cursor: default;
    border: $border-narrow-dark;

    .dialog-form {
        width: 25rem;
        & > * {
            padding: 0 1rem;
        }
        .instrument-name-container {
            margin: 1rem 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .instrument-code {
                flex: 1;
            }
            .instrument-eq {
                margin: 0 1rem;
            }
            .instrument-input {
                flex: 1;
                background-color: $light-3;
                border: $border-narrow-dark;
                color: $dark-5;
                padding-right: 0;
            }
        }
        .update-message-div {
            color: $light;
            text-align: center;
            margin: 1rem 0;
            font-size: 1rem;
        }
        .dialog-action-container {
            width: 100%;
            display: flex;
            justify-content: space-between;
            border-top: $border-narrow-dark;
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
            .btn {
                font-weight: bold !important;
                &.btn-submit {
                    padding-left: 3rem;
                    padding-right: 3rem;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.update-notification {
    position: fixed;
    right: 0;
    left: 0;
    top: $header-height;

    .b-toast {
        max-width: unset;
        background-color: $dark-4;

        .toast {
            display: flex;
            justify-content: center;
            max-width: unset;
            border: solid 1px $red;
            background-color: rgba($red, 0.1);
            color: $red;
            border-radius: 0;
            font-size: 15px;
        }
    }
}
</style>
